export default __webpack_public_path__ + "static/EC-3-2fef6f8550126721aee4d940f8aadb2d.png";